<div
    class="theme2 menu-container py-3 px-6 shadow-2 flex align-items-center justify-content-between relative lg:static">
    <a href=""><img src="assets/img/logo-new.png" alt="Image" height="50"></a>
    <a class="block lg:hidden p-element cursor-pointer text-700" (click)="toggleMenu()"><i
            class="pi pi-bars text-4xl"></i></a>
    <div [ngClass]="{'hidden': showMenu}" style="margin-top: -8px;"
        class="menu-content align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full left-0 top-100 lg:px-6 lg:px-0 z-2 shadow-2 lg:shadow-none">
        <section></section>

        <div class="card">
            <p-tabMenu [model]="items" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>
        </div>
        <div
            class="header-actions flex justify-content-center border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
            <!-- <button pButton pRipple [routerLink]="'/plans'" label="Pricing" class="p-element p-ripplee p-button-text mr-3 font-bold p-button p-component">
         </button> -->

            <button *ngIf="!loggedIn" pButton pRipple [routerLink]="'/login'" [label]="'public-menu.login' | translate"
                class="header-button">
            </button>
            <button *ngIf="loggedIn" pButton pRipple [routerLink]="'/b/dashboard'"
                [label]="'public-menu.dashboard' | translate" class="header-button">
            </button>
            <button *ngIf="!loggedIn" pButton pRipple [routerLink]="'/register'"
                [label]="'public-menu.register' | translate" class="header-button">
            </button>
            </div>

    </div>
</div>
